import { Link } from "react-router-dom";
import { Facebook, Instagram, Music2, Phone, MessageCircle, Clock } from "lucide-react";
import { Logo } from "./Logo";
import { BUSINESS } from "../data/content";

const NAV = [
  ["Home", "/"], ["About", "/about"], ["Services", "/services"], ["Portfolio", "/portfolio"],
  ["Reviews", "/reviews"], ["FAQ", "/faq"], ["Contact", "/contact"],
];

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-[rgba(255,255,255,0.07)] bg-[#0B0C1A] mt-0">
    <div className="container-x py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
      <div>
        <Logo withTagline />
        <p className="text-[#A0A3C2] text-sm mt-5 max-w-xs leading-relaxed">
          Websites and video ads for small businesses worldwide — one remote studio, a direct line to the makers.
        </p>
        <div className="flex gap-3 mt-6">
          <a href={BUSINESS.social.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="footer-facebook" className="p-2.5 rounded-full border border-[rgba(255,255,255,0.12)] text-[#A0A3C2] hover:text-[#00D9C0] hover:border-[#00D9C0] transition-colors"><Facebook size={17} /></a>
          <a href={BUSINESS.social.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-instagram" className="p-2.5 rounded-full border border-[rgba(255,255,255,0.12)] text-[#A0A3C2] hover:text-[#00D9C0] hover:border-[#00D9C0] transition-colors"><Instagram size={17} /></a>
          <a href={BUSINESS.social.tiktok} target="_blank" rel="noopener noreferrer" aria-label="TikTok" data-testid="footer-tiktok" className="p-2.5 rounded-full border border-[rgba(255,255,255,0.12)] text-[#A0A3C2] hover:text-[#00D9C0] hover:border-[#00D9C0] transition-colors"><Music2 size={17} /></a>
        </div>
      </div>
      <nav className="grid grid-cols-2 gap-x-8 gap-y-3 content-start" aria-label="Footer">
        {NAV.map(([label, to]) => (
          <Link key={to} to={to} data-testid={`footer-link-${label.toLowerCase()}`} className="text-[#A0A3C2] hover:text-[#F5F5FA] no-underline text-sm transition-colors py-1">
            {label}
          </Link>
        ))}
      </nav>
      <div className="text-sm text-[#A0A3C2] space-y-3">
        <a href={BUSINESS.phoneHref} data-testid="footer-phone" className="flex items-center gap-2.5 text-[#A0A3C2] hover:text-[#F5F5FA] no-underline transition-colors">
          <Phone size={15} className="text-[#00D9C0]" /> {BUSINESS.phoneDisplay} / {BUSINESS.phoneIntl}
        </a>
        <a href={BUSINESS.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-2.5 text-[#A0A3C2] hover:text-[#25D366] no-underline transition-colors">
          <MessageCircle size={15} className="text-[#25D366]" /> WhatsApp us anytime
        </a>
        <p className="flex items-start gap-2.5 m-0"><Clock size={15} className="text-[#00D9C0] mt-0.5 shrink-0" /> {BUSINESS.hours}</p>
        <p className="m-0 pt-2 text-xs text-[#A0A3C2]/70">{BUSINESS.social.handle} on Facebook, Instagram & TikTok</p>
      </div>
    </div>
    <div className="border-t border-[rgba(255,255,255,0.07)]">
      <div className="container-x py-5 flex flex-col sm:flex-row justify-between gap-2 text-xs text-[#A0A3C2]/70">
        <span>© {new Date().getFullYear()} BHF Creative. All rights reserved.</span>
        <span>Remote studio · Serving clients worldwide</span>
      </div>
    </div>
  </footer>
);
